/* eslint-disable @typescript-eslint/no-explicit-any */

export const isEmptyText = (str?: string) => {
    if (str === null || str === undefined) return true;
    return str.trim() === '';
};

export const getUTCDateFormate = (date: Date|undefined)=>{
    if(date) {
       return new Date(Date.UTC(date.getFullYear(),date.getMonth(),date.getDate()));
    }
    return undefined;
};

export const isNothing = (obj: any) => {

    return obj === '' || obj === null || obj === undefined;
};

export const checkArbicLang = (lang?: string) =>{
    
    if(lang) {
        return  lang.trim().toLowerCase().startsWith('ar');
    }
    return false;
    
};

export const dateOnly = (date?: Date | null) => {
    if (date) {
        return new Date(`${date.toDateString()} 00:00:00`);
    }
    return undefined;
};

export const getBooleanValue = (val: string): boolean => {
    if (val){
        if (val.toString().toLowerCase() === 'true' || val.toString() === '1')
            return (true);
    }
    return (false);
};

